import React from 'react';
import './InstallationStepList.scss';

interface InstallationStepListProps {
  children: React.ReactNode;
}

export default function InstallationList({ children }: InstallationStepListProps) {
  return (
    <ul className='installation-step-list' aria-label='installation step list' style={{ display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '350px' }}>
        {children}
      </div>
    </ul>
  );
}
